module.exports = __webpack_public_path__ + "static/work-1-bf9af8ea8a94ed9ff9a6ccfd205fb137.png";